import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../components/Select/index';
import 'parsleyjs';
import MaskedInput from 'react-text-mask';

class PortfolioForm extends Component {
    handleInputChange = event => {
        let { portfolioData, updatePortfolioData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;
            let tmpSelected = _.extend({}, portfolioData);
            tmpSelected[name] = value;
            updatePortfolioData(tmpSelected);
        }
    };

    handleSelectChange = (name, value, valueKey) => {
        let { portfolioData, updatePortfolioData } = this.props;
        let tmpSelected = _.extend({}, portfolioData);
        if (value !== null) {
            if (valueKey) {
                tmpSelected[name] = value[valueKey];
            } else {
                tmpSelected[name] = value[name];
            }
        } else {
            tmpSelected[name] = '';
        }
        updatePortfolioData(tmpSelected);
    };

    handleMaskedInputChange = event => {
        let { portfolioData, updatePortfolioData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.value === ''
                    ? target.value
                    : parseInt(target.value.replace(/[-]/g, ''), 10);
            const name = target.name;
            let tmpSelected = _.extend({}, portfolioData);
            tmpSelected[name] = value;
            updatePortfolioData(tmpSelected);
        }
    };

    render() {
        let {
            portfolioData,
            parentTrusts,
            fundTypeList,
            isEditable,
            countryList,
            stateList,
            formRef
        } = this.props;
        return (
            <form ref={formRef}>
                {parentTrusts && (
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>*Trust</label>
                            <Select
                                clearable={false}
                                labelKey="name"
                                valueKey="trustId"
                                name="trustId"
                                selectedValue={portfolioData.trustId}
                                onChange={this.handleSelectChange}
                                options={parentTrusts}
                                disabled={!isEditable}
                                required={true}
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Edgar Series Id</label>
                        <input
                            className="form-control"
                            type="text"
                            name="edgarSeriesId"
                            value={portfolioData.edgarSeriesId}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={portfolioData.name}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Formerly Known As Names</label>
                        <input
                            className="form-control"
                            type="text"
                            name="formerlyKnownAsNames"
                            value={portfolioData.formerlyKnownAsNames}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="4000"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Client Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="clientCode"
                            value={portfolioData.clientCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Feid</label>
                        <input
                            className="form-control"
                            type="text"
                            name="feid"
                            value={portfolioData.feid}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="9"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Fund Type</label>
                        <Select
                            clearable={false}
                            name="fundType"
                            labelKey="enumName"
                            valueKey="enumId"
                            options={fundTypeList}
                            selectedValue={portfolioData.fundType}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            required={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Federal ID</label>
                        <MaskedInput
                            id="portfolioFederalId"
                            mask={[
                                /\d/,
                                /\d/,
                                '-',
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/
                            ]}
                            className="form-control"
                            type="text"
                            name="federalId"
                            value={
                                portfolioData.federalId === 0
                                    ? ''
                                    : portfolioData.federalId
                            }
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                        {/*Following hidden input is added for parsley validation*/}
                        <input
                            type="text"
                            style={{ display: 'none' }}
                            value={
                                portfolioData.federalId === 0
                                    ? ''
                                    : portfolioData.federalId
                            }
                            readOnly
                            data-parsley-length="[9,9]"
                            data-parsley-error-message="This value length is invalid. It should be 9 characters long."
                            data-parsley-class-handler={'#portfolioFederalId'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12 form-separator">
                        <span className="form-separator-title">
                            Adviser Information
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Adviser Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="adviserName"
                            value={portfolioData.adviserName}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Adviser Email</label>
                        <input
                            className="form-control"
                            type="text"
                            name="adviserEmail"
                            value={portfolioData.adviserEmail}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="email"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Adviser Sec File Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="adviserSecFileNumber"
                            value={portfolioData.adviserSecFileNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="number"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Adviser Crd Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="adviserCrdNumber"
                            value={portfolioData.adviserCrdNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="number"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>AdviserLegalEntityId</label>
                        <input
                            className="form-control"
                            type="text"
                            name="adviserLegalEntityId"
                            value={portfolioData.adviserLegalEntityId}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Adviser State</label>
                        <Select
                            name="adviserStateId"
                            labelKey="name"
                            valueKey="stateId"
                            options={stateList}
                            selectedValue={portfolioData.adviserStateId}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Adviser Country Id</label>
                        <Select
                            name="adviserCountryId"
                            labelKey="name"
                            valueKey="countryId"
                            options={countryList}
                            selectedValue={portfolioData.adviserCountryId}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12 form-separator">
                        <span className="form-separator-title">
                            Sub Adviser Information
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sub Adviser Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="subAdviserName"
                            value={portfolioData.subAdviserName}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sub Adviser Email</label>
                        <input
                            className="form-control"
                            type="text"
                            name="subAdviserEmail"
                            value={portfolioData.subAdviserEmail}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="email"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sub Adviser Sec File Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="subAdviserSecFileNumber"
                            value={portfolioData.subAdviserSecFileNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="number"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sub Adviser Crd Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="subAdviserCrdNumber"
                            value={portfolioData.subAdviserCrdNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-type="number"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Sub Adviser Legal Entity Id</label>
                        <input
                            className="form-control"
                            type="text"
                            name="subAdviserLegalEntityId"
                            value={portfolioData.subAdviserLegalEntityId}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Sub Adviser State</label>
                        <Select
                            name="subAdviserStateId"
                            labelKey="name"
                            valueKey="stateId"
                            options={stateList}
                            selectedValue={portfolioData.subAdviserStateId}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Sub Adviser Country Id</label>
                        <Select
                            name="subAdviserCountryId"
                            labelKey="name"
                            valueKey="countryId"
                            options={countryList}
                            selectedValue={portfolioData.subAdviserCountryId}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

PortfolioForm.propTypes = {
    portfolioData: PropTypes.object.isRequired,
    parentTrusts: PropTypes.array,
    fundTypeList: PropTypes.array.isRequired,
    updatePortfolioData: PropTypes.func,
    countryList: PropTypes.array.isRequired,
    stateList: PropTypes.array.isRequired,
    isEditable: PropTypes.func.bool
};

PortfolioForm.defaultProps = {
    isEditable: true
};

export default PortfolioForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/PortfolioForm.js